<template>
  <div class="vrun-form-sas">
    <component
      v-for="item in component.items"
      :key="item.nid"
      :lang="component.vrun_form_lang_nid"
      :controller="component['vrun_form_sas:sas_controller']"
      :component="vRunScope.instances[item.nid]"
      :is="getVueComponent(vRunScope.instances[item.nid]['vrun_form_sas:type'])"
    ></component>
  </div>
</template>

<script>
import { angularInvoke } from "/vodalys/vvuejs";
import { getVueComponent } from "./vrun_form.sas.parcel.mjs";
export default {
  components: {},
  methods: {
    getVueComponent: function (type) {
      console.log('getVueComponent 1', type);
      return getVueComponent(type);
    },
  },
  props: {
    component: Object,
  },
  mounted: function () {
    var _zis = this;
    angularInvoke(function (vRunScope) {
      _zis.vRunScope = vRunScope;
      console.log(_zis);
    });
  },
};
</script>

<style lang="scss">
</style>